import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    items: [
      { label: '攻略指南', path: '/category/gonglue' },
      { label: '剧情解析', path: '/category/juqing' },
      { label: '角色图鉴', path: '/category/jiaose' },
      { label: '冒险日志', path: '/category/maoxian' },
      { label: '奇幻设定', path: '/category/qihuan' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑评价', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '友情链接',
    items: [
      { label: '重生萝莉岛攻略', path: '/category/gonglue' },
      { label: '重生萝莉岛剧情', path: '/category/juqing' },
      { label: '重生萝莉岛角色', path: '/category/jiaose' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50 whitespace-nowrap">
              重生萝莉岛
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              全新冒险等你开启。融合萌系角色与奇幻剧情，带你体验神秘岛屿的无限可能与热血冒险。
            </p>
          </div>
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold text-background-100 mb-4 text-sm">{section.title}</h4>
              <ul className="flex flex-col gap-2">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 重生萝莉岛. 保留所有权利。
          </p>
          <p className="text-sm text-background-500">
            萌系重生故事 | 萝莉岛冒险 | 重生奇幻岛屿
          </p>
        </div>
      </div>
    </footer>
  );
}